import { createTelegramPlatform, telegramWebApp } from './telegram';
import { createWebPlatform } from './web';
import type { Platform } from './types';

const tg = telegramWebApp();
export const platform: Platform = tg ? createTelegramPlatform(tg) : createWebPlatform();
export type { Platform } from './types';
